
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State } from 'vuex-class';
import moment from "moment";

import PaginationMiniComponent from '@/components/paginations/PaginationMini.vue';

@Component({
  components: {
    PaginationMiniComponent,
  },
})
export default class IncomeAdvertising extends Vue {

  /* VUEX */

  // ACTION
  @Action('actionSelectAdvertisementRevenue', { namespace: 'advertisement'})
  private actionSelectAdvertisementRevenue: any;
  @Action('actionPaginationAdvertisementRevenue', { namespace: 'advertisement'})
  private actionPaginationAdvertisementRevenue: any;
  @Action('actionDownloadRevenue', { namespace: 'advertisement'})
  private actionDownloadRevenue: any;

  @State('array_advertisement_revenue', { namespace: 'advertisement'})
  private array_advertisement_revenue: any;
  @State('pagination_advertisement_revenue', { namespace: 'advertisement'})
  private pagination_advertisment_revenue: any;
  @State('locale')
  private locale: string;

  /* INITIALIZATION */

  private searchParams: any = {
    month: null,
    year: null,
  };
  private array_month: any[] = [
    {
      name: 'January',
      translation: 'Januari',
      value: 1,
    },
    {
      name: 'February',
      translation: 'Februari',
      value: 2,
    },
    {
      name: 'March',
      translation: 'Maret',
      value: 3,
    },
    {
      name: 'April',
      translation: 'April',
      value: 4,
    },
    {
      name: 'May',
      translation: 'Mei',
      value: 5,
    },
    {
      name: 'June',
      translation: 'Juni',
      value: 6,
    },
    {
      name: 'July',
      translation: 'Juli',
      value: 7,
    },
    {
      name: 'August',
      translation: 'Agustus',
      value: 8,
    },
    {
      name: 'Sepetember',
      translation: 'September',
      value: 9,
    },
    {
      name: 'October',
      translation: 'Oktober',
      value: 10,
    },
    {
      name: 'November',
      translation: 'November',
      value: 11,
    },
    {
      name: 'December',
      translation: 'Desember',
      value: 12,
    },
  ];

  private manageSlots: any[] = []

  private showPopupManageAds:boolean = false
  private isEditable:boolean = false

  constructor() {
    super();
  }

  private created() {
    this.actionSelectAdvertisementRevenue({params: this.searchParams});
  }

  private getMonth(month:string) {
    return moment(month,"MM").format("MMMM")
  }

  /* METHOD */

  private clickSearch() {
    this.actionSelectAdvertisementRevenue({params: this.searchParams});
  }

  private getLabel(label: string): string {
    if (this.locale === 'id') {
      return 'translation';
    }
    return label;
  }
}
